import React, { useEffect, useRef, useState } from "react";
import {
  useAppDispatch,
  useAppSelector,
  getActiveAnnouncementsThunk,
} from "../../redux";
import megaphoneIcon from "../../assets/icons/megaphone-purple.svg";
import "./AnnouncementBell.css";

const AnnouncementBell: React.FC = () => {
  const dispatch = useAppDispatch();
  const containerRef = useRef<HTMLDivElement>(null);
  const [isOpen, setIsOpen] = useState(false);

  const announcements = useAppSelector(
    (state) => state.announcement.activeRecords,
  );

  useEffect(() => {
    dispatch(getActiveAnnouncementsThunk());
    const interval = setInterval(() => {
      dispatch(getActiveAnnouncementsThunk({ force: true }));
    }, 60000);
    return () => clearInterval(interval);
  }, [dispatch]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="announcement-bell-container" ref={containerRef}>
      <button
        type="button"
        className={`announcement-bell-btn ${isOpen ? "active" : ""}`}
        onClick={() => setIsOpen((prev) => !prev)}
        aria-label="Announcements"
        title="Announcements"
      >
        <img src={megaphoneIcon} alt="Announcements" width={20} height={20} />
        {announcements.length > 0 && (
          <span className="announcement-badge">
            {announcements.length > 99 ? "99+" : announcements.length}
          </span>
        )}
      </button>

      {isOpen && (
        <div className="announcement-dropdown-menu">
          <div className="announcement-dropdown-header">
            <h4 className="announcement-dropdown-title">Announcements</h4>
          </div>
          <div className="announcement-dropdown-list">
            {announcements.length === 0 && (
              <div className="announcement-dropdown-empty">
                No announcements right now.
              </div>
            )}
            {announcements.map((item) => (
              <div className="announcement-dropdown-item" key={item.id}>
                <span className="announcement-dropdown-sender">
                  {item["Teacher.Name"] || "Teacher"}
                </span>
                <span className="announcement-dropdown-text">
                  {item.Description}
                </span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default AnnouncementBell;
